var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"target":"_blank","href":(_vm.isTestnet ? 'https://testnetexplorer.obyte.org/#' : 'https://explorer.obyte.org/#')+_vm.unit}},[_c('v-icon',{staticClass:"pt-05",attrs:{"name":"external-link","size":"is-small"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }